import { getIsProdEnv } from "@/constants";
import { getWorkerName } from "@/helpers/getWorkerName";
import type { User } from "@dndbeyond/auth/types/user";

export const getPhysicsWorker = async (
  nodeEnv: string,
  env: string,
  user?: User,
) => {
  if (process.env.NODE_ENV === "development") {
    const { getDevPhysicsWorker } = await import("../getDevPhysicsWorker");

    return getDevPhysicsWorker(nodeEnv, env, user);
  }

  return new Worker(
    `/dice/${getIsProdEnv(env) ? "mobile" : "previewer"}/physicsWorker.${process.env.NEXT_PUBLIC_PHYSICS_WORKER_HASH}.js`,
    {
      name: getWorkerName("physics", nodeEnv, env, user),
      type: "module",
    },
  );
};
